import React from 'react';
import BaseTablePage from '../../elements/BaseTablePage'
import Pagination from '../../elements/Pagination'
import { AggregateMobileSearchForm } from './AggregateMobileSearchForm'
import { AggregateMobileTableUI } from './AggregateMobileTableUI'

//import { GhorePrizePage } from '../../components/GhorePrizePage'


export class AggregateMobileTable extends BaseTablePage {

  constructor(props) {
    super(props);
    this.getDataUrl = "api/v1/GetAggergtateMobile?offset=";
    this.getExcelUrl = "/api/v1/GetAggergtateMobileExcel";
    this.className = "AggergtateMobile";
    this.state.mode = "table";
    this.state.searchData = {};

  }


  render() {
    //  if (!this.state.isLoaded) {
    //  return <div className="box-body"> در حال بارگذاری</div>;
    // }

    //console.log()
    return (
      <div className="container">
        <AggregateMobileSearchForm onSubmit={this.onSubmitSearchData} onExcelClick={this.onExcelButtonClick} searchData={this.state.searchData} />
        <AggregateMobileTableUI data={this.state.data} onViewClick={this.onViewClick} />
        <Pagination pageNumber={this.state.pageNumber} count={this.state.count} perPageCount={this.state.pageSize} onChange={this.handleChangePage} />
        

      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/tables/aggregateMobile/AggregateMobileTable.js